import { EFormStatusHistory } from './e-form-status-history.model';
import { EFormSurveyField } from './e-form-survey-field.model';
import { EFormDatabaseField } from './e-form-database-field.model';
import { EFormSurveyAnswer } from './e-form-survey-answer.model';
import { CSTField } from '../../shared-modules/customization-framework/models/custom-data-field.model';

export class EForm {
    ID: number;
    Instance_ID: number;
    ParentMem_ID: number;
    PrimaryParentMem_ID: number;
    ParentName: string;
    Student_ID: number;
    Staff_ID: number;
    StudentNames: string[] = [];
    strStudentId: string[] = [];
    FormData: string;
    Status: string;
    StaffNote: string;
    CreatedOn: Date;
    CreatedBy: number;
    CreatedByName: string;
    LastUpdatedOn: Date;
    LastUpdatedBy: number;
    LastUpdatedByName: string;
    StatusHistory: EFormStatusHistory[] = [];
    SubmittedDate: Date;
    SubmittedName: string;
    DelStatus: boolean;
    Required: boolean;
    Student: string;
    DueDate: Date;
    StartDate: Date;
    EndDate: Date;
    AllowMultiple: boolean;
    InstanceName: string;
    TemplateType: string;
    SubmittedOn: Date;
    SubmittedBy: number;
    SubmittedByName: string;
    ManualSubmission: boolean;
    UserCanProcess: boolean;
    //Type: string;
    UserType: number;
    StudentIds: number[] = [];
    IsInstanceActive: string;
    AYIdentifier: string;
    Family_ID: number;
    Year_ID: number;
    StudentIDs: number[] = [];
    //  Behavior Letter specific properties
    Template_ID: number;
    Incident_ID: number;
    PDFDataBase64: string;
    School_ID: number;
    GradeLevel_ID: number;
    IsLastStatusDelete: boolean;
    InvolvementType: string;
    // Translated language PDF Variables
    TranslatedPDF: string;
    TranslatedJSON: string;
    EnglishJSON: string;
    DocToFamily_ID: Number;
    Non_English = false;
    SurveyFields: EFormSurveyField[];
    IsSurvey: boolean;
    IsMobile: boolean;
    DisplayCriticalMessage: boolean;
    CriticalMessage: string;
    Frequency: string;
    StudentsCanComplete: boolean;
    ParentsCanComplete: boolean;
    NonResidentParentsCanComplete: boolean;
    StaffCanComplete: boolean;
    CompletionDue = false;
    CompletionDueOption: string;
    DatabaseFields: EFormDatabaseField[];
    CustomFields: CSTField[];
    SurveyAnswers: EFormSurveyAnswer[];
    HasBeenReOpened: boolean;        
    EnglishPDF: string;
    StaffName: string;
    FormAYIdentifier: string;
    PDFNameOverride: string;
    GradeLevel: string;

    Cell_number:string;
    Home_Number:string;
    Address:string;
    Email_Address:string;
    ShowInAllYears:boolean;
    NonresidentParents = false;

    // Attendance Letter Only
    TrackingType: number;
    BatchRunDate: Date;
}

export class EFormSelectedStudentInfo {
    StudentNumber: string;
    LastName: string;
    FirstName: string;
    Grade: string;
    EnrollDate?: Date;
    DateOfBirth?: Date;
    SchoolName: string;
    StudentCount?: number;
}

export class EFormAvilableCount {
    instanceId: string;
    eFormsAvailable: number;
    optionaleFormAvailable: number;
}
